/**
 * @description function that returns the api call preferences object
 * @param preferences 
 * @returns 
 */
export const formatPreferences = (preferences: string,t:any) => {
    let model = [
        { "type": "ECONOMIC", "enabled": false },
        { "type": "SUSTAINABLE", "enabled": false },
        { "type": "FAST", "enabled": false },
        { "type": "DIRECT", "enabled": false }
    ];
    if (preferences === t("PMyPreferenesLiterals.switchhorizontal.slot3")) model[0].enabled = true;//Económico
    if (preferences === t("PMyPreferenesLiterals.switchhorizontal.slot4")) model[1].enabled = true;//Ecologico
    if (preferences === t("PMyPreferenesLiterals.switchhorizontal.slot2") ) model[2].enabled = true;//Rapidas
    if (preferences === t("PMyPreferenesLiterals.switchhorizontal.slot1")) model[3].enabled = true;//Directas

    return model;

}

/**
 * @description function that returns the call api formated object
 * @param dateObject 
 * @returns 
 */
export const formatDate = (dateObject: any) => {
    return [dateObject.year, dateObject.month, dateObject.day].join("-")
}

/**
 * 
 * @description function that returns the favourite call api object
 * @param favouriteTransports 
 * @returns 
 */
export const formatFavouriteTransports = (favouriteTransports: any) => {
    let model = [
        {
            "type": "TRAIN",
            "enabled": false
        },
        {
            "type": "METRO",
            "enabled": false
        },
        {
            "type": "BUS",
            "enabled": false
        },
        {
            "type": "TAXI-VTC",
            "enabled": false
        },
    
    ]
    favouriteTransports.forEach((element: any) => {
        if (element.id === "ave") model[0].enabled = true;
        if (element.id === "metro") model[1].enabled = true;
        if (element.id === "busLD") model[2].enabled = true;
        if (element.id === "taxiVtc") model[3].enabled = true;

    });

    return model;

}

export function nameRegisterLiterals(t: any) {
    return {
        title: t("nameRegisterLiterals.title"),
        desc: t("nameRegisterLiterals.desc"),
        buttonBottom: t("nameRegisterLiterals.buttonBottom"),
        formatErrorMessage: t("nameRegisterLiterals.formatErrorMessage"),
        textError: {
          maintext: t("nameRegisterLiterals.textError.maintext"),
        },
        inputName: {
          maintext: t("nameRegisterLiterals.inputName.maintext"),
        },
        inputSurname: {
          maintext: t("nameRegisterLiterals.inputSurname.maintext"),
        },
        inputSecSurn: {
          maintext: t("nameRegisterLiterals.inputSecSurn.maintext"),
        }
    }
}


export function idRegisterLiterals(t: any) {
    return {
        title: t("idRegister.title"),
        desc: t("idRegister.desc"),
        componenttitle: t("idRegister.componenttitle"),
        componentdesc: t("idRegister.componentdesc"),
        choice: {
          slot1: t("idRegister.choice.slot1"),
          slot2: t("idRegister.choice.slot2"),
          slot3: t("idRegister.choice.slot3"),
        },
        input: {
          maintext: t("idRegister.input.maintext"),
        },
        button: t("idRegister.button"),
        literalStateDNI: {
          comptitle: t("idRegister.literalStateDNI.comptitle"),
          compdesc: t("idRegister.literalStateDNI.compdesc"),
          errorinput: t("idRegister.literalStateDNI.errorinput")
        },
        literalStateNIE: {
            comptitle: t("idRegister.literalStateNIE.comptitle"),
            compdesc: t("idRegister.literalStateNIE.compdesc"),
            errorinput: t("idRegister.literalStateNIE.errorinput")
        },
        literalStatePassport: {
            comptitle: t("idRegister.literalStatePassport.comptitle"),
            compdesc: t("idRegister.literalStatePassport.compdesc"),
            errorinput: t("idRegister.literalStatePassport.errorinput")
        }
    }
}


export function phoneRegisterLiterals(t: any) {
    return {
        title1:t("phoneRegisterLiterals.title1"),
        title2: t("phoneRegisterLiterals.title2"),
        desc: t("phoneRegisterLiterals.desc"),
        buttonBottom: t("phoneRegisterLiterals.buttonBottom"),
        msjError: {
          maintext: t("phoneRegisterLiterals.msjError.maintext"),
        },
        inputPrefix: {
          maintext: t("phoneRegisterLiterals.inputPrefix.maintext"),
        },
        inputPhone: {
          maintext: t("phoneRegisterLiterals.inputPhone.maintext"),
        },
    }
}

export function birthdayRegisterLiterals(t: any) {
    return {
        title: t("birthdayRegisterLiterals.title"),
        desc: t("birthdayRegisterLiterals.desc"),
        title2: t("birthdayRegisterLiterals.title2"),
        example: t("birthdayRegisterLiterals.example"),
        texterror: { maintext: t("birthdayRegisterLiterals.texterror.maintext"),},
        inputDAY: { maintext:t("birthdayRegisterLiterals.inputDAY.maintext")},
        inputMONTH: { maintext: t("birthdayRegisterLiterals.inputMONTH.maintext") },
        inputYEAR: { maintext: t("birthdayRegisterLiterals.inputYEAR.maintext")},
        button1: t("birthdayRegisterLiterals.button1"),
        button2: t("birthdayRegisterLiterals.button2"),
    }
}


export function postalAddressRegisterLiterals(t: any) {
    return {
        title: t("postalAddressRegisterLiterals.title"),
        desc: t("postalAddressRegisterLiterals.desc"),
        buttonBottom: t("postalAddressRegisterLiterals.buttonBottom"),
        form: {
          streetAddress: t("postalAddressRegisterLiterals.form.streetAddress"),
          postalCode: t("postalAddressRegisterLiterals.form.postalCode"),
          locality: t("postalAddressRegisterLiterals.form.locality"),
          region: t("postalAddressRegisterLiterals.form.region"),
          country: t("postalAddressRegisterLiterals.form.country"),
        },
        msjerr: {
          streetAddress: t("postalAddressRegisterLiterals.msjerr.streetAddress"),
          postalCode: t("postalAddressRegisterLiterals.msjerr.postalCode"),
          locality: t("postalAddressRegisterLiterals.msjerr.locality"),
          region: t("postalAddressRegisterLiterals.msjerr.region"),
          country: t("postalAddressRegisterLiterals.msjerr.country"),
        },
    }
}


export function preferencesRegisterLiterals(t: any) {
    return {
        title:  t("preferencesRegisterLiterals.title"),
        desc: t("preferencesRegisterLiterals.desc"),
        switchvertical: {slot1: t("preferencesRegisterLiterals.switchvertical.slot1"), slot2: t("preferencesRegisterLiterals.switchvertical.slot2"), slot3: t("preferencesRegisterLiterals.switchvertical.slot3"), slot4: t("preferencesRegisterLiterals.switchvertical.slot4") },
        button1: t("preferencesRegisterLiterals.button1"),
        button2: t("preferencesRegisterLiterals.button2"),
        descCard:[
            t("preferencesRegisterLiterals.descCard.0"),
            t("preferencesRegisterLiterals.descCard.1"),
            t("preferencesRegisterLiterals.descCard.2"),
            t("preferencesRegisterLiterals.descCard.3"),
          ]

        
    }
}




export function confirmRegisterLiterals(t: any) {
    return {
        title: t("confirmRegisterLiterals.title"),
        title2: t("confirmRegisterLiterals.title2"),
        desc: t("confirmRegisterLiterals.desc"),
        button: t("confirmRegisterLiterals.button"),
    }
}


export function idDuplicatedLiterals(t: any) {
    return {
        title: t("idDuplicatedLiterals.title"),
        desc: t("idDuplicatedLiterals.desc"),
        buttonText: t("idDuplicatedLiterals.buttonText"),
        secondaryButtonText: t("idDuplicatedLiterals.secondaryButtonText"),
        cancelButton: t("idDuplicatedLiterals.cancelButton"),
    }
}

